import { createGetPropGetter } from '@/store/utils';

export default {
  activities: createGetPropGetter('activities', []),
  activitiesLoading: createGetPropGetter('activitiesLoading', false),
  activityData: createGetPropGetter('activityData', null),
  reportActivities: createGetPropGetter('reportActivities', []),
};
